import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

type SFCheckIconProps = Omit<SvgIconProps, "color"> & {
  color: string;
};

export default function SFCheckIcon({ color, ...props }: SFCheckIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="24"
        height="24"
        viewBox="-6 -6 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.27454 9.62015C3.50218 9.87112 3.80364 10 4.1051 10C4.40656 10 4.70802 9.87112 4.93566 9.62015L11.6539 2.21299C12.1154 1.70426 12.1154 0.8835 11.6539 0.38155C11.1925 -0.127183 10.4481 -0.127183 9.99282 0.38155L4.11125 6.8662L2.00718 4.55316C1.54576 4.04443 0.801333 4.04443 0.346065 4.55316C-0.115355 5.0619 -0.115355 5.88265 0.346065 6.3846L3.27454 9.62015Z"
          fill={color}
        />
      </svg>
    </SvgIcon>
  );
}
